import { containsOperationRuntimeConfig, createRuntimeOperationType, isRecord, } from './common';
export const generateUrlStorageOperationType = createRuntimeOperationType({
    kind: 'GENERATE_URL_STORAGE',
    dependencies: () => [],
    run: (value, context) => {
        if (!Array.isArray(value)) {
            return value;
            throw new Error(`GENERATE_URL_STORAGE value must be an array. Got ${JSON.stringify(value)}`);
        }
        const urlSearchParams = value
            .map(item => {
            if (!isRecord(item)) {
                return item;
            }
            const urlSearchParams = new URLSearchParams(Object.entries(item)
                .map(([key, value]) => {
                if (containsOperationRuntimeConfig(value)) {
                    return null;
                }
                try {
                    const stringifiedValue = JSON.stringify(value);
                    return [key, stringifiedValue];
                }
                catch (error) {
                    return null;
                }
            })
                .filter(Boolean));
            return urlSearchParams.toString();
        })
            .join('&');
        if (urlSearchParams) {
            return `?${urlSearchParams}`;
        }
        return '';
    },
});
//# sourceMappingURL=generate-url-storage.js.map